import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';

const LoginPageContainer = styled.div`
  max-width: 450px;
  margin: 5rem auto;
  padding: 2.5rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  text-align: center;
`;

const Title = styled.h1`
  margin-bottom: 1rem;
`;

const Subtitle = styled.p`
  color: #666;
  margin-bottom: 2rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Input = styled.input`
  padding: 12px 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
`;

const Button = styled.button`
  padding: 15px;
  background-color: #005eb8;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
`;

const LoginErrorContainer = styled.div`
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1.5rem;
  text-align: center;
  line-height: 1.5;
`;

const Login = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const loginError = location.state?.error === 'email-not-found';

  useEffect(() => {
    if (location.state?.emailForRetry) {
      setEmail(location.state.emailForRetry);
    }
  }, [location.state]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Pass a flag to indicate this is a fresh login request that needs a code.
    // Replace history state so user can't go back to the error state.
    navigate('/verify-login', { state: { email, fromLogin: true }, replace: true });
  };

  return (
    <LoginPageContainer>
      <Title>Sign In</Title>
      {loginError ? (
        <LoginErrorContainer>
          no email address found on our system, please try another one
        </LoginErrorContainer>
      ) : (
        <Subtitle>Enter your email address to receive a login code.</Subtitle>
      )}
      <Form onSubmit={handleSubmit}>
        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="your.email@example.com" required />
        <Button type="submit">Continue</Button>
      </Form>
    </LoginPageContainer>
  );
};

export default Login;